<template>
  <!-- <lk-upload :action="url" @on-success='success' @on-error='error'> -->
  <!-- <lk-button :icon="icon" @click="upload">{{name}}</lk-button> -->
  <!-- </lk-upload> -->
  <div class="uploaderContainer">
    <div class="uploader" @click="$refs.file.click()" v-show="(!url)&&able ">
      <!-- <img v-if="upImg" :src="upImg" alt="" > -->
      <input type="file" ref="file" @change="fileReader" v-show="false">
      <!-- <span class="iconfont">&#xe60d;</span> -->
      <p>
        <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>点击上传
      </p>
    </div>
    <div v-show="url" class="fileHolder">
      <div class="cover">


        <span class="btn" @click="handleFile">
          <!-- <lk-icon type="md-document" size="16" class="mr8" /> -->
          <i class="iconfont"  v-if='picList.includes(fileType)'>&#xe620;</i>
          <i class="iconfont"  v-if='wordList.includes(fileType)'>&#xe621;</i>
          <i class="iconfont"  v-if='excList.includes(fileType)'>&#xe612;</i>
          <i class="iconfont" v-if="fileType==='pdf'">&#xe622;</i>
          <span>文件已上传，可点击查看</span>
          </span>
        <lk-icon type="md-close" @click="deleteImg" v-if="able && showDetIcon" size="22" class="del" />
      </div>

    </div>

    <lk-modal title="图片详情" v-model="imgDetail" width='50%'  :closable='false'>
      <div class="detailContainer">
        <img :src=" url?decodeURIComponent(url) :''" alt="" :style='{width:"100%"}' >
      </div>
    </lk-modal>
  </div>
</template>
<script>
// import OSS from 'ali-oss';
import upload from '../services/upload';
import utils from '../libs/utils';

export default {
  name: 'uploader',
  data() {
    return {
      acciptList: ['image/png', 'image/jpeg', 'image/gif', 'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/wps-writer',
        'text/csv',
        '',
        'application/msword'],
      picList: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp'],
      excList: ['', 'xls', 'xlsx'],
      wordList: ['doc', 'docx'],

      loading: false,
      imgDetail: false,
      token: '',
      upImg: '',
      file: null,
      showImg: false,
      type: '',
    };
  },
  props: {
    name: {
      type: String,
      default: '上传',
    },
    icon: {
      type: String,
    },
    url: {
      type: String,
      // default: '',
    },
    label: {
      type: String,
      default: '',
    },
    able: {
      type: Boolean,
      default: false,
    },
    showDetIcon: {
      type: Boolean,
      default: true,
    },
    upIndex: {
      type: Number,
      default: -1,
    },
    format: {
      type: Array,
      default() {
        return [];
      },
    },
    maxSize: Number,
  },
  model: {// 更新组件v-model
    prop: 'url',
    event: 'handle',
  },
  computed: {
    fileType() {
      let type = decodeURIComponent(this.url).slice(0, decodeURIComponent(this.url).indexOf('?'));
      type = type.slice(type.lastIndexOf('.') + 1).toLowerCase();
      const lastType = decodeURIComponent(this.url).slice(decodeURIComponent(this.url).lastIndexOf('.') + 1).toLowerCase();
      return this.picList.includes(type) ? type : lastType;
    },
  },
  mounted() {
  },
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },
    deleteImg() {
      this.$emit('handle', '');
      if (this.upIndex !== -1) {
        this.$emit('deleteUpload', this.upIndex);
      }
      // this.$emit('judgeVal', false);// 判定是否有上传
      this.dispatch('FormItem', 'on-form-change', '');

      // this.url = ''; //
    },
    viewImg() {},
    fileReader(e) {
      this.loading = true;
      const fr = new FileReader();
      this.file = e.target.files[0];
      const typeName = this.file.name.slice(this.file.name.lastIndexOf('.') + 1);
      const typeNameLower = typeName.toLowerCase();
      const defaultFormatLList = [
        ...this.picList,
        ...this.excList,
        ...this.wordList,
        'pdf',
      ];

      let fileFlag = false; // 是否符合上传规则

      if (this.format.length) { // 如果传递了format, 则只根据扩展名称进行判断
        fileFlag = this.format.includes(typeNameLower);
      } else if (this.acciptList.includes(this.file.type) || defaultFormatLList.includes(typeNameLower)) {
        fileFlag = true;
      }

      // 不符合上传规则
      if (!fileFlag) {
        this.file = null;
        this.$refs.file.value = '';
        this.$Message.error('不支持该文件上传，请更换文件');
        return;
      }

      // 检查文件是否超限
      if (this.maxSize) {
        if (this.file.size > this.maxSize * 1024 * 1024) {
          this.file = null;
          this.$refs.file.value = '';
          this.$Message.error(`文件超过${this.maxSize}M限制，请更换文件`);
          return false;
        }
      }
      // 选择文件中的头一个开始读取,将img读取为base64编码可以被img直接解析
      fr.readAsDataURL(e.target.files[0]);
      fr.onload = () => {
        this.handleUpload(this.file.name);

        e.target.value = null; // 解决change事件重复选择同一文件是不能重新渲染载入事件
      };
    },
    async getToken(name) {
      return new Promise((resolve) => {
        upload.getToken(name)
          .then((res) => {
            if (res.data.status === 200) {
              resolve(res.data.data);
            } else {
              this.loading = false;
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            this.loading = false;
            utils.handleError(err);
          });
      });
    },
    handleFile() {
      if (this.picList.includes(this.fileType.toLowerCase())) {
        this.imgDetail = true;
      } else {
        window.open(this.transformUrlToHttps(decodeURIComponent(this.url)));
      }
    },
    async handleUpload(name) {
      const token = await this.getToken(name);
      // console.log();
      token.host = `${window.location.protocol}//${token.host}`;

      upload
        .upload(this.file, token)
        .then((res) => {
          // console.log(res);

          if (res.status === 200) {
            // console.log(res);
            this.$Message.success('上传成功');
            if (this.upIndex !== -1) {
              const upName = this.file.name.slice(0, this.file.name.lastIndexOf('.'));
              this.$emit('handlerUploadName', this.upIndex, upName);
            }
            upload.getFile({
              bucket: token.bucket,
              objectName: token.dir + token.objectName,
            }).then((innerRes) => {
              if (innerRes.data.status === 200) {
                this.$emit('handle', encodeURIComponent(innerRes.data.data));

                this.dispatch('FormItem', 'on-form-change', encodeURIComponent(innerRes.data.data));
              } else {
                this.loading = false;
                this.$Message.error(innerRes.data.error);
              }
            }).catch((err) => {
              this.loading = false;
              utils.handleError(err);
            });
          } else {
            this.loading = false;
            this.$Message.error('上传失败');
          }
        })
        .catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
    },
    transformUrlToHttps(url) {
      if (!url) {
        return
      }
      let index = url.indexOf(':');
      if (index !== -1) {
        let str = url.slice(index);
        console.log(`https${str}`);
        return `https${str}`;
      }
    }
  },
};
</script>
<style lang="less" scoped>
.uploaderContainer{
  position: relative;
  // border: 1px dashed #dedede;
  height: 100%;
  // width: 80px;
}
.uploader {
  height: 28px;
  width: 87px;
  border: 1px dashed #dedede;
  text-align: center;
  // padding-top: 20px;
  position: relative;
  // padding: 50px 0;
  cursor: pointer;
  line-height: 1.2;
  p {
  line-height: 28px;
    // line-height: 1;
    font-size: 12px
  }
  // line-height: 145px
}
.fileHolder {
  height: 28px;

  // width: 80px;
  display: flex;
  align-items: center;
  // justify-content: space-around;
  // background: #ccc;
  // line-height: 1;
  position: relative;
  // border: 1px dashed #dedede;
}
.cover {
  // position: absolute;
  // padding: 0 8px;
  width: 100%;
  display: flex;
justify-content: space-between;
align-items: center;
.btn{
  cursor: pointer;
  display: flex;
  align-items: center;
  .iconfont{
    font-size: 16px;
    margin-right: 8px;
    // color: #1890FF
  }
}
.del{
  display: none;
  cursor: pointer;
}
  // height: 80px;
  // background: #000;
  // text-align: right
  // opacity: 0;
}

.cover:hover {
  // opacity: 1;
  background:#F5F5F5 ;
.del{
  display: block
}

}

.detailContainer{
  overflow: hidden;
}
</style>
